<style>
	:global(.modalSelect > .mdc-menu-surface) {
		position: fixed !important;
		top: auto !important;
		left: auto !important;
		width: auto !important;
	}
</style>

<script lang="ts">
	import Button, { Label } from '@smui/button';
	import Select, { Option } from '@smui/select';
	import LinearProgress from '@smui/linear-progress';
	import { createEventDispatcher, onDestroy } from 'svelte';
	import { _ } from 'svelte-i18n';
	import FieldLoading from '../../../..//shared/components/common/Loading/FieldLoading.svelte';
	import IndirizzoDipendente from '../../../../shared/models/Dipendente/IndirizzoDipendente';
	import Sede from '../../../../shared/models/Sede/Sede';
	import { userSession } from '../../../../shared/stores';
	const dispatch = createEventDispatcher();

	let [dataSedi, loadingSedi, errorSedi] = Sede.getList({ areaId: $userSession?.areaId, aziendaEnteId: $userSession?.aziendaEnteId });

	let fileInput: HTMLInputElement;
	let files: FileList;
	let isImporting = false;
	let unsubscribers = [];

	let selectedSede: Sede = new Sede();

	function onFileSelected() {
		if (!files || files.length === 0) return;
		
		isImporting = true;
		dispatch('importStart'); // Notifica che l'importazione è iniziata
		
		const formData = new FormData();
		formData.append('sedeId', selectedSede.id.toString());
		formData.append('context', 'IndirizziDipendenti');
		formData.append('file', files[0]);

		// La funzione import ritorna [data, loading, error] che sono Writable
		const [data, loading, error] = IndirizzoDipendente.import(formData);
		
		let hasStartedLoading = false;
		
		// Sottoscrizione al loading per sapere quando è completato
		const unsubscribeLoading = loading.subscribe((isLoading) => {
			if (isLoading) {
				// L'importazione è iniziata
				hasStartedLoading = true;
			} else if (hasStartedLoading && !isLoading) {
				// L'importazione è completata (loading è passato da true a false)
				isImporting = false;
				dispatch('importEnd'); // Notifica che l'importazione è finita
				selectedSede = new Sede();
				dispatch('updateData', [data, loading, error]);
				// Cleanup
				unsubscribers.forEach(unsub => unsub());
				unsubscribers = [];
			}
		});
		
		// Sottoscrizione anche all'error per gestire eventuali errori
		const unsubscribeError = error.subscribe((hasError) => {
			if (hasError) {
				isImporting = false;
				dispatch('importEnd'); // Notifica che l'importazione è finita (con errore)
				dispatch('updateData', [data, loading, error]);
				// Cleanup
				unsubscribers.forEach(unsub => unsub());
				unsubscribers = [];
			}
		});
		
		unsubscribers = [unsubscribeLoading, unsubscribeError];
	}
	
	// Cleanup on component destroy
	onDestroy(() => {
		unsubscribers.forEach(unsub => unsub());
	});
</script>

<form class="flex flex-col p-4">
	{#if isImporting}
		<div class="flex flex-col items-center justify-center p-8 min-h-[300px]">
			<div class="w-full max-w-md">
				<LinearProgress indeterminate />
			</div>
			<p class="mt-4 text-lg font-medium text-gray-700">
				Importazione indirizzi in corso...
			</p>
			<p class="mt-2 text-sm text-gray-500">
				Attendere prego, l'operazione potrebbe richiedere alcuni secondi.
			</p>
		</div>
	{:else}
		<div class="flex flex-col justify-between flex-grow">
			<div class="w-full">
				{#if $loadingSedi}
					<FieldLoading customClass="md:col-start-2" />
				{:else}
					<Select
						label="{$_('page.pscl.detail.location')}"
						key="{(sede) => `${(sede && sede.id) || ''}`}"
						bind:value="{selectedSede}"
						class="modalSelect md:col-start-2"
						required
					>
						{#if $dataSedi.response}
							{#each $dataSedi.response as sede (sede.id)}
								{#if sede.denominazione}
									<Option value="{sede}">{sede.denominazione}</Option>
								{/if}
							{/each}
						{/if}
					</Select>
				{/if}
			</div>

			<div class="p-4">
				<input
					type="file"
					id="uploader-btn"
					bind:files="{files}"
					bind:this="{fileInput}"
					hidden
					on:change="{onFileSelected}"
					accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
				/>
				<Button
					disabled="{!selectedSede?.id || selectedSede?.id == 0}"
					variant="raised"
					type="button"
					for="uploader-btn"
					on:click="{() => { fileInput.value = ''; fileInput.click(); }}"
				>
					<Label>Importa</Label>
				</Button>
			</div>
		</div>
	{/if}
</form>